import React from "react";
import { User, LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export interface InlineOptionRowProps {
  value: string;
  isSelected: boolean;
  onSelect: (value: string) => void;
  /** Left-side icon component. Defaults to `User`. */
  icon?: LucideIcon;
  children: React.ReactNode;
}

/**
 * Shared option button for inline floating-dropdown selects. Renders a
 * full-width left-aligned button with an icon and content slot; uses
 * `onMouseDown` so the click fires before the input blur closes the panel.
 */
export function InlineOptionRow({
  value,
  isSelected,
  onSelect,
  icon: Icon = User,
  children,
}: InlineOptionRowProps) {
  return (
    <button
      key={value}
      type="button"
      className={cn(
        "w-full text-left px-3 py-2.5 text-sm hover:bg-muted/80 transition-colors flex items-start gap-2",
        isSelected && "bg-primary/10"
      )}
      onMouseDown={(e) => {
        e.preventDefault();
        onSelect(value);
      }}
    >
      <Icon className="h-4 w-4 shrink-0 text-muted-foreground mt-0.5" />
      <div className="flex-1 min-w-0">{children}</div>
    </button>
  );
}
